import { render } from "./LiveDataForId.vue?vue&type=template&id=2ef84ff4"
import script from "./LiveDataForId.vue?vue&type=script&lang=js"
export * from "./LiveDataForId.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__